import { Component, Input, Output, EventEmitter, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { AlertService } from '../../alert.service';
import { OrderService } from '../../order.service';

@Component({
  selector: 'tea-shop-fe-review-order',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './review-order.component.html',
  styleUrls: ['./review-order.component.css']
})
export class ReviewOrderComponent {
  private alertService = inject(AlertService);
  private orderService = inject(OrderService);

  @Input() orderId?: string;
  @Input() rating? = 0;
  @Input() comment?: string;
  @Output() reviewSubmitted = new EventEmitter<{rating: number, comment?: string}>();

  stars = [1, 2, 3, 4, 5];
  isSubmitting = false;

  setRating(star: number): void {
    this.rating = star;
  }

  canSubmit(): boolean {
    return (this.rating ?? 0) > 0;
  }

  submitReview(): void {
    if (!this.canSubmit()) {
      this.alertService.show({
        title: 'Please select a rating',
        description: 'You must select a rating before submitting your review.',
        type: 'warning'
      });
      return;
    }

    if (!this.orderId) {
      this.alertService.show({
        title: 'Error',
        description: 'Order ID is required to submit a review.',
        type: 'error'
      });
      return;
    }

    this.isSubmitting = true;

    const reviewData = {
      starRating: this.rating ?? 5,
      reviewText: this.comment
    };

    this.orderService.submitOrderReview(this.orderId, reviewData).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.alertService.show({
          title: 'Review Submitted',
          description: 'Thank you for your review! It has been saved successfully.',
          type: 'success'
        });
        this.reviewSubmitted.emit({
          rating: this.rating ?? 5,
          comment: this.comment
        });
      },
      error: (error) => {
        this.isSubmitting = false;
        console.error('Error submitting review:', error);
        this.alertService.show({
          title: 'Error',
          description: 'Failed to submit your review. Please try again.',
          type: 'error'
        });
      }
    });
  }
}
